import React from "react"
import { Route, Routes } from "react-router-dom"
import NotFound from './containers/notFound'
import Login from './containers/login'
import Signup from './containers/signup'
import Home from './containers/home'
import Clinical from './containers/clinical'
import DataSharing from './containers/datasharing'
import IOP from './containers/datasharing2'
import EMR from './containers/emr'
import Contact from './containers/contactCard'

export default function Links({ childProps }) {
  return (
    <Routes>
      <Route path="/" element={<Home {...childProps} />} />
      <Route path="/login" element={<Login {...childProps} />} />
      <Route path="/signup" element={<Signup {...childProps} />} />
      <Route path="/clinical" element={<Clinical {...childProps} />} />
      <Route path="/datasharing" element={<DataSharing {...childProps} />} />
      <Route path="/iop" element={<IOP {...childProps} />} />
      <Route path="/emr" element={<EMR {...childProps} />} />
      <Route path="/contact/:id" element={<Contact {...childProps} />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
  
}